import React from 'react';
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
    const { user } = useContext(AuthContext); // Verifica si el usuario está autenticado

    // Si no hay un usuario autenticado, redirige al login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Si el usuario está autenticado, renderiza el contenido
    return children;
};

export default PrivateRoute;
